export const CS_MESSAGE_CHANNEL = 'live-preview'
export const CS_URL = 'https://eu-app.contentstack.com'
export const CONTENT_STACK_ENDPOINT = 'https://eu-graphql.contentstack.com'
export const CONTENT_STACK_LIVE_PREVIEW_ENDPOINT =
	'https://eu-graphql-preview.contentstack.com'
export const CS_EVENT_MANAGER = 'contentstack-adv-post-message'
export const LANDINGS_DEVELOPMENT_LIVE_PREVIEW_TOKEN =
	'cs8c56f0a2fef826df8af7fb03'
